import styled from 'styled-components'

const NavbarStyle = styled.div`
  position: fixed;
  top: -1px;
  width: 100%;
  height: 10vh;
  color: ${(props) => props.theme.text};
  font-family: ${(props) => props.theme.font};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  z-index: 10;
  transition: 0.25s;
  background-color: ${({ scrolled }) => (scrolled ? 'black' : 'transparent')};
  font-family: 'Montserrat', sans-serif;

  h1 {
    font-weight: 600;
  }

  p {
    margin: 0 1rem;
    cursor: pointer;
    transition: 0.5s;
    &:hover {
      color: ${(props) => props.theme.primary};
    }
  }

  .highlight {
    color: ${(props) => props.theme.primary};
  }

  .mobile-nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: absolute;
  }

  @media (max-width: 768px) {
    padding: 0 10px;
  }
  @media (max-width: 500px) {
    padding: 2px 5px;
  }
`

export default NavbarStyle
